import UnitTable from 'components/Unit/UnitTable';
import { Paths, UnitType } from 'constants/index';

const Table = () => {
  return (
    <UnitTable path={Paths.ADMIN_SAMPLERS_VIEW} type={UnitType.SAMPLER} />
  );};

export default Table;
